import bem from 'utils/bem';

export const block = bem('post-task');
export const blockOverlay = bem('post-task-overlay');
export const discoBlock = bem('post-task-disco-section');
